export default "__VITE_ASSET__8nTdltUH__"